import PropTypes from 'prop-types';
import { Button } from '@bwoty-web/styleguide';

import styles from './FilterBarFooter.scss';

const propTypes = {
  resetFilterLabel: PropTypes.node,
  showFilteredLabel: PropTypes.node,
  onReset: PropTypes.func,
  onShowFiltered: PropTypes.func,
  disableShowFiltered: PropTypes.bool,
  showReset: PropTypes.bool,
};

export const FilterBarFooter = (props) => {
  const {
    showReset,
    resetFilterLabel,
    showFilteredLabel,
    onReset,
    onShowFiltered,
    disableShowFiltered,
  } = props;

  return (
    <div className={styles.root}>
      {showReset ? (
        <div>
          <Button theme="gray" onClick={onReset}>
            {resetFilterLabel}
          </Button>
        </div>
      ) : null}
      <div>
        <Button
          className={styles.showButton}
          onClick={onShowFiltered}
          disabled={disableShowFiltered}
          data-gtm-tag="Show filtered trips"
        >
          {showFilteredLabel}
        </Button>
      </div>
    </div>
  );
};

FilterBarFooter.propTypes = propTypes;
